/**
 * Espelha regras de backend/utils/certDownloadUtils.js (UI).
 */
export const CERT_INVALID_MESSAGE =
  "Certificado digital inválido ou vencido. Atualize o certificado para acessar o portal.";

export function companyDependsOnCertificate(company) {
  const method = company?.portal_auth_method || "password";
  if (method === "certificate") return true;
  const hasLogin = Boolean(
    company?.portal_login && String(company.portal_login).trim(),
  );
  if (hasLogin) return false;
  return company?.cert_status && company.cert_status !== "none";
}

export function isCertificateInvalidForLogin(company) {
  if (!companyDependsOnCertificate(company)) return false;
  const status = company?.cert_status || "none";
  return status === "expired" || status === "none";
}
